import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import WastageAddEditComponent from "../../../component/inventory/wastage/WastageAddEditComponent";

export default function WastageAdd() {
  return (
    <div className="flex flex-col">
      <Header
        title={`McDonalds Food Chains`}
        menu={constants.MENU.INVENTORY}
        currentMenuKey={"T_7_S_7_L_7"}
      />
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.MENU.INVENTORY}
        />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent
              title={"Add Wastage"}
              listRoute="/inventory/wastage"
            />
          </div>

          <div className="w-[688px] bg-white mx-auto">
            <WastageAddEditComponent />
          </div>

        </div>
      </div>
    </div>
  );
}
